import { ticketStatuses } from '../global.enum';

export const boxModel = {
  headquartersList: [],
  boxList: [],
  priorityList: [],
  queueList: [],
  ticketList: [],
  assignmentDetail: {
    arrayAttentionQueue: [],
    arrayAttentionType: [],
    boxCode: null,
    userCode: null,
    attentionType: null,
  },
};

export const extractCodes = (principalCodeName, arrayValues) => {
  return arrayValues.map((value) => value[principalCodeName]);
};

export const existCustomersToCall = (ticketList) => {
  return (
    ticketList.length > 0 &&
    ticketList.some((ticket) => !(ticket.statusCode === ticketStatuses.PAUSE))
  );
};

export const verifyAssignment = ({
  attentionType,
  boxCode,
  headquartersCode,
  userCode,
}) => {
  return !!(attentionType && boxCode && headquartersCode !== null && userCode);
};

export const getNextCustomer = (listTickets, boxCode) => {
  return listTickets.find(
    (ticket) =>
      (ticket.boxCode === null || ticket.boxCode === boxCode) &&
      !(ticket.statusCode === ticketStatuses.PAUSE)
  );
};
